import useAuth from '@nobia/zeus-components/lib/auth/useAuth'
import { useMemo } from 'react'

import { useStaffMembers } from '../../components/store'

/**
 * Resolves the logged-in designer's staff id for the current store (email match).
 * Returns '' when unresolved - matches SearchCustomersQuery filter expectations.
 */
export const useCurrentStaffId = (storeId) => {
  const { profile } = useAuth()
  const { staffMembers, loading } = useStaffMembers(storeId)

  const staffId = useMemo(() => {
    const email = profile?.email?.toLowerCase()
    if (!email || !staffMembers?.length) return ''
    const match = staffMembers.find((s) => {
      const staffEmail = s.email?.toLowerCase()
      const staffPersonalEmail = s.personalEmail?.toLowerCase()
      return staffEmail === email || staffPersonalEmail === email
    })
    return match?.id != null ? `${match.id}` : ''
  }, [profile, staffMembers])

  return { staffId, loading }
}

export default useCurrentStaffId
